export default "__VITE_ASSET__DGLoMxtT__"